module.exports = __webpack_public_path__ + "img/eth-icon.fdf25a59.svg";